
import { Timestamp } from 'firebase/firestore'



export class CompanyProfile{
  constructor(
    company_profile_id="",
    name="",
    address={
      street: "",
      unit: "",
      city: "",
      state: "",
      zip: "",
    },
    phone="",
    email="",
    website_url="",
    logo_url="",
    in_business_since="",
    bio="",
    description="",
    mission="",
    created_time = new Date(),
    updated_time = new Date(),
    service_states=[],
    reviews=[],
    rating={
      score: 0,
      totalReviews: 0
    }
  ){
    this.company_profile_id = company_profile_id
    this.name = name
    this.address = address
    this.phone = phone
    this.email = email
    this.website_url = website_url
    this.logo_url = logo_url
    this.in_business_since = in_business_since
    this.bio = bio
    this.description = description
    this.mission = mission
    this.created_time = created_time
    this.updated_time = updated_time
    this.service_states = service_states
    if (!this.logo_url && this.name){
      this.logo_url = this.calculateLogoUrl()
    }
    this.reviews = reviews
    this.rating = rating
  }

  calculateLogoUrl(){
    let sanitizedName = this.name.replace(/[^a-zA-Z0-9]/g, '')
    sanitizedName = sanitizedName.toLowerCase()
    
    let split = this.name.split(' ')
    let firstLetter = sanitizedName[0]
    let lastLetter = split.length > 1 ? split[1][0]:sanitizedName[sanitizedName.length - 1]


    let logoUrl = `https://ui-avatars.com/api/?name=${firstLetter}+${lastLetter}&size=512`
    return logoUrl
  }
}

export const CompanyProfileConverter = {
  toFirestore: function(companyProfile){
    return {
      company_profile_id: companyProfile.company_profile_id || null,
      name: companyProfile.name,
      address: companyProfile.address,
      phone: companyProfile.phone,
      email: companyProfile.email,
      website_url: companyProfile.website_url,
      logo_url: companyProfile.logo_url,
      in_business_since: companyProfile.in_business_since,
      bio: companyProfile.bio,
      description: companyProfile.description,
      mission: companyProfile.mission,
      created_time: Timestamp.fromDate(companyProfile.created_time),
      updated_time: Timestamp.now(),
      service_states: companyProfile.service_states || [],
      reviews: companyProfile.reviews || [],
      rating: companyProfile.rating || {
        score: 0,
        totalReviews: 0
      }
    }
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options)
    return new CompanyProfile(
      snapshot.id,
      data.name,
      data.address,
      data.phone,
      data.email,
      data.website_url,
      data.logo_url,
      data.in_business_since,
      data.bio,
      data.description,
      data.mission,
      data.created_time.toDate(),
      data.updated_time.toDate(),
      data.service_states || [],
      data.reviews || [],
      data.rating
    )
  }
}